import { render, staticRenderFns } from "./PreviewArticles.vue?vue&type=template&id=60cae43e&scoped=true"
import script from "./PreviewArticles.vue?vue&type=script&lang=js"
export * from "./PreviewArticles.vue?vue&type=script&lang=js"
import style0 from "./PreviewArticles.vue?vue&type=style&index=0&id=60cae43e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cae43e",
  null
  
)

export default component.exports